"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddingTabPanel = void 0;
const react_redux_1 = require("react-redux");
const React = require("react");
const FlexParent_1 = require("../../util/FlexParent");
const core_1 = require("@material-ui/core");
const ProjectionControlCard_1 = require("./ProjectionControlCard/ProjectionControlCard");
const ProjectionOpenDuck_1 = require("../../Ducks/ProjectionOpenDuck");
const ProjectionWorkerDuck_1 = require("../../Ducks/ProjectionWorkerDuck");
const GenericSettings_1 = require("./GenericSettings/GenericSettings");
const ProjectionParamsDuck_1 = require("../../Ducks/ProjectionParamsDuck");
const ProjectionColumnsDuck_1 = require("../../Ducks/ProjectionColumnsDuck");
const TSNEEmbeddingController_1 = require("./EmbeddingController/TSNEEmbeddingController");
const UMAPEmbeddingController_1 = require("./EmbeddingController/UMAPEmbeddingController");
const ClusterTrailSettings_1 = require("./ClusterTrailSettings/ClusterTrailSettings");
const TrailSettingsDuck_1 = require("../../Ducks/TrailSettingsDuck");
const ForceAtlas2EmbeddingController_1 = require("./EmbeddingController/ForceAtlas2EmbeddingController");
const mapStateToProps = (state) => ({
    currentAggregation: state.currentAggregation,
    stories: state.stories,
    storyMode: state.storyMode,
    projectionWorker: state.projectionWorker,
    projectionOpen: state.projectionOpen,
    dataset: state.dataset,
    webGLView: state.webGLView,
    projectionParams: state.projectionParams
});
const mapDispatchToProps = dispatch => ({
    setProjectionOpen: value => dispatch(ProjectionOpenDuck_1.setProjectionOpenAction(value)),
    setProjectionWorker: value => dispatch(ProjectionWorkerDuck_1.setProjectionWorkerAction(value)),
    setProjectionParams: value => dispatch(ProjectionParamsDuck_1.setProjectionParamsAction(value)),
    setProjectionColumns: value => dispatch(ProjectionColumnsDuck_1.setProjectionColumns(value)),
    setTrailVisibility: visibility => dispatch(TrailSettingsDuck_1.setTrailVisibility(visibility))
});
const connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
exports.EmbeddingTabPanel = connector((props) => {
    const [open, setOpen] = React.useState(false);
    const [domainSettings, setDomainSettings] = React.useState('');
    const [controller, setController] = React.useState(null);
    return React.createElement(FlexParent_1.FlexParent, { alignItems: 'stretch', flexDirection: 'column', justifyContent: '' },
        React.createElement(core_1.Box, { p: 1 },
            React.createElement(ProjectionControlCard_1.ProjectionControlCard, { controller: controller, onClose: () => {
                    if (controller) {
                        controller.terminate();
                    }
                    setController(null);
                    props.setTrailVisibility(false);
                }, onComputingChanged: (e, newVal) => {
                } })),
        React.createElement(core_1.Box, { p: 1 },
            React.createElement(core_1.Button, { style: {
                    width: '100%'
                }, variant: "outlined", onClick: () => {
                    setDomainSettings('umap');
                    setOpen(true);
                } }, 'UMAP')),
        React.createElement(core_1.Box, { p: 1 },
            React.createElement(core_1.Button, { style: {
                    width: '100%'
                }, variant: "outlined", onClick: () => {
                    setDomainSettings('tsne');
                    setOpen(true);
                } }, 't-SNE')),
        React.createElement(core_1.Box, { p: 1 },
            React.createElement(core_1.Button, { style: {
                    width: '100%'
                }, variant: "outlined", onClick: () => {
                    setDomainSettings('forceatlas2');
                    setOpen(true);
                } }, 'ForceAtlas2')),
        React.createElement(GenericSettings_1.GenericSettings, { projectionParams: props.projectionParams, domainSettings: domainSettings, open: open, onClose: () => setOpen(false), onStart: (params, selection) => {
                setOpen(false);
                props.setProjectionColumns(selection);
                props.setProjectionParams(params);
                switch (domainSettings) {
                    case 'tsne': {
                        let controller = new TSNEEmbeddingController_1.TSNEEmbeddingController();
                        controller.init(props.dataset, selection, params);
                        controller.stepper = (Y) => {
                            props.dataset.vectors.forEach((vector, i) => {
                                vector.x = Y[i][0];
                                vector.y = Y[i][1];
                            });
                            props.webGLView.current.updateXY();
                            props.webGLView.current.repositionClusters();
                        };
                        setController(controller);
                        break;
                    }
                    case 'umap': {
                        let controller = new UMAPEmbeddingController_1.UMAPEmbeddingController();
                        let samples = params.useSelection ? props.currentAggregation : props.dataset.vectors;
                        controller.init(props.dataset, selection, params, params.useSelection ? samples : undefined);
                        controller.stepper = (Y) => {
                            let source = controller.boundsY(Y);
                            let target = controller.targetBounds;
                            samples.forEach((sample, i) => {
                                if (controller.targetBounds) {
                                    sample.x = target.x + ((Y[i][0] - source.x) / source.width) * target.width;
                                    sample.y = target.y + ((Y[i][1] - source.y) / source.height) * target.height;
                                }
                                else {
                                    sample.x = Y[i][0];
                                    sample.y = Y[i][1];
                                }
                            });
                            props.webGLView.current.updateXY();
                            props.webGLView.current.repositionClusters();
                        };
                        setController(controller);
                        break;
                    }
                    case 'forceatlas2': {
                        let controller = new ForceAtlas2EmbeddingController_1.ForceAtlas2EmbeddingController();
                        controller.init(props.dataset, selection, params);
                        controller.stepper = (Y) => {
                            props.dataset.vectors.forEach((sample, i) => {
                                let idx = controller.nodes[sample.view.duplicateOf].view.meshIndex;
                                sample.x = Y[idx].x;
                                sample.y = Y[idx].y;
                            });
                            props.webGLView.current.updateXY();
                        };
                        setController(controller);
                        break;
                    }
                }
            } }),
        React.createElement(ClusterTrailSettings_1.ClusterTrailSettings, null));
});
